var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBasicPlan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 113,
    height: 113,
    viewBox: "0 0 113 113",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5586",
    "data-name": "Group 5586",
    transform: "translate(0.861 0.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_498",
    "data-name": "Ellipse 498",
    cx: 56,
    cy: 56,
    r: 56,
    transform: "translate(-0.361)",
    fill: "#f4f4f4",
    stroke: "#e0e0e0",
    strokeWidth: 1,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Boeing",
    transform: "translate(19.491 20.358)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M0,0H71.9V71.9H0Z",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M14.872,17.307a1.438,1.438,0,1,1,1.777,2.262h0l-6.773,5.32V28.5h7.208a1.438,1.438,0,0,1,0,2.876H8.438A1.438,1.438,0,0,1,7,29.942H7V24.19a1.438,1.438,0,0,1,.55-1.131h0Zm14.035.232a1.438,1.438,0,0,1,2.021-.224h0l7.187,5.752a1.438,1.438,0,0,1,.539,1.123h0v5.752a1.438,1.438,0,0,1-1.438,1.438H28.57a1.438,1.438,0,1,1,0-2.876h7.208V24.881l-6.647-5.32A1.438,1.438,0,0,1,28.907,17.539Z",
    transform: "translate(13.132 31.893)",
    fill: "#fe9920"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    "data-name": "Path",
    d: "M23.549,39.389H6.134A4.309,4.309,0,0,1,2,34.917V29.506a4.517,4.517,0,0,1,2.4-4.059l17.626-8.484a2.453,2.453,0,0,1,.339-.133l-.224-4.253a10.048,10.048,0,0,1,9.5-10.563Q31.907,2,32.171,2A10.048,10.048,0,0,1,42.217,12.049q0,.264-.014.528l-.221,4.2,18.043,8.756A4.485,4.485,0,0,1,62.4,29.561v5.376a4.3,4.3,0,0,1-4.135,4.452H40.793l-.82,15.6a7.812,7.812,0,0,1-15.6,0ZM22.525,19.914,5.674,28.024a1.647,1.647,0,0,0-.8,1.482v5.411a1.463,1.463,0,0,0,1.259,1.6H23.4l-.873-16.6Zm18.419,16.6H58.262a1.45,1.45,0,0,0,1.26-1.576V29.561a1.619,1.619,0,0,0-.774-1.451l-16.93-8.215-.874,16.619ZM32.171,4.876q-.188,0-.377.01a7.172,7.172,0,0,0-6.784,7.54l2.23,42.415a4.937,4.937,0,0,0,9.861,0l2.23-42.415q.01-.188.01-.377A7.172,7.172,0,0,0,32.171,4.876Z",
    transform: "translate(3.752 3.752)",
    fill: "#0c4767"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasicPlan);
export default __webpack_public_path__ + "static/media/basic-plan.1b12c19d2fce0e390fbfb35e3a4bdf9f.svg";
export { ForwardRef as ReactComponent };